import React from 'react';
import { Button } from '@alefeducation/ui-elements-library-core';
import styled from 'styled-components';
import { CANCEL } from '../../utils/constants';

const StyledFooter = styled.div`
  display: flex;
  justify-content: right;
  column-gap: 16px;
  padding: 24px 24px 40px;
  border-top: 1px solid ${({ theme }: any) => theme.colors.primary[10]};
`;

interface Props {
  submitButtonText: string;
  isSubmitDisabled?: boolean;
  hideCancelButton?: boolean;
  onSubmit: () => void;
  onCancel?: () => void;
}

const Footer = ({
  isSubmitDisabled,
  hideCancelButton = false,
  onSubmit,
  onCancel = () => {},
  submitButtonText,
}: Props) => {
  return (
    <StyledFooter data-testid="create-role-footer">
      {!hideCancelButton && (
        <Button variant="secondary" onClick={onCancel}>
          {CANCEL}
        </Button>
      )}
      <Button variant="primary" disabled={isSubmitDisabled} onClick={onSubmit}>
        {submitButtonText}
      </Button>
    </StyledFooter>
  );
};

export default Footer;
